<div class="coupon-card-slim-root" (click)="openCouponDetails()">
  <div class="left">
    <span class="name">
      {{coupon.productName ?? coupon.rewardName}}
    </span>
    <div class="description">
      {{coupon.rewardDescription}}
    </div>
    <div class="label-area">
      <span class="expiring-date">
        {{labels.issuedDate}}: {{ coupon.redeemDate | date:'d MMM y' : '' :  language }}
      </span>
      <span class="expiring-date">
        {{labels.expirationDate}}: {{ coupon.expirationDate | date:'d MMM y' : '' :  language }}
      </span>
      <span *ngIf="hasDisclaimer" class="disclaimer-label">
        {{labels.disclaimer}}
      </span>
    </div>
  </div>
  <div class="right">
    <div class="points-area">
      <span *ngIf="coupon.status === activeStatus" class="status" [ngStyle]="{'color': getStatusColor(coupon.status)}">
        {{labels.active}}
      </span>
      <span *ngIf="coupon.status === redeemedStatus" class="status" [ngStyle]="{'color': getStatusColor(coupon.status)}">
        {{labels.redeemed}}
      </span>
      <span *ngIf="coupon.status === canceledStatus" class="status" [ngStyle]="{'color': getStatusColor(coupon.status)}">
        {{labels.canceled}}
      </span>
      <span *ngIf="coupon.status === expiredStatus" class="status" [ngStyle]="{'color': getStatusColor(coupon.status)}">
        {{labels.expired}}
      </span>
      <app-sticker-icon small icon="stars">{{cost | number:'': language}}</app-sticker-icon>
    </div>
    <div class="button-area">
      <app-secondary-button *ngIf="coupon.status === activeStatus" auxiliary (click)="copy(); $event.stopPropagation()">
        {{labels.copyCouponCode}}
      </app-secondary-button>
      <app-secondary-button *ngIf="coupon.status === redeemedStatus" auxiliaryLightBlue (click)="openRewardDetails(); $event.stopPropagation()">
        {{labels.seeRewardsDetails}}
      </app-secondary-button>
      <app-secondary-button *ngIf="coupon.status === canceledStatus" auxiliaryLightBlue (click)="openRewardDetails(); $event.stopPropagation()">
        {{labels.seeRewardsDetails}}
      </app-secondary-button>
      <div *ngIf="!loading">
        <app-secondary-button *ngIf="coupon.status === expiredStatus" auxiliaryLightBlue (click)="openRewardDetails(); $event.stopPropagation()">
          <span *ngIf="!loading">{{labels.seeRewardsDetails}}</span>
        </app-secondary-button>
      </div>
      <div class="loading" *ngIf="loading"><mat-spinner diameter="15" [ngClass]="{hidden: !loading}"></mat-spinner></div>
    </div>

    <span class="error" *ngIf="!successfulReactivation">{{labels.error}} </span>
  </div>
</div>
